import { Component, EventEmitter, inject, Inject, Output } from '@angular/core';
import { CamelCasePipe } from '../../utils/camel-case.pipe';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiEnvNames, ExportConfig } from '../../model/api.model';
import { CommonUtils } from '../../utils/common.utils';
import { CommonService } from '../../services/common.service';
import { EXCEL_EXTENSION } from '../../services/excel-export.service';
import { SPINNER_AREA, SpinnerArea } from '../../model/common.model';
import { BrandEditileExportSearchConfig } from '../../model/tenure/brand-tenure.model';
import { SpinnerComponent } from '../../layout/spinner/spinner.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-tenure-attachment-display',
  standalone: true,
  imports: [CamelCasePipe,SpinnerComponent,MatIconModule],
  templateUrl: './tenure-attachment-display.component.html',
  styleUrl: './tenure-attachment-display.component.scss'
})
export class TenureAttachmentDisplayComponent {

  @Output() closeCliked: EventEmitter<any> = new EventEmitter<any>();
    private readonly commonUtils = inject(CommonUtils);
    private readonly service = inject(CommonService);
      public spinnerName: SpinnerArea = SPINNER_AREA['Popup'];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  onCloseClicked() {
    this.closeCliked.emit({});
  }
    downloadFile = (file:any) => {
      const exportConfig: ExportConfig = {
        tableSchema: this.data['tableSchema'],
        environment: ApiEnvNames['StaffMaster'],
        fileExtension: EXCEL_EXTENSION,
        searchParameters: BrandEditileExportSearchConfig,
        exportFileName: '',
      };
      if(file) {
        this.commonUtils.spinner('show',this.spinnerName);
        this.service.downloadExcelFromS3(file, exportConfig).then(()=>{
          this.commonUtils.spinner('hide',this.spinnerName);
        }).catch(()=>{
          this.commonUtils.spinner('hide',this.spinnerName);
        })
      }
    }  
}
